"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc998TemplateFormValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.erc998TemplateFormValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    price: mui_inputs_asset_1.templateAssetValidationSchema,
    amount: yup_rules_eth_1.bigNumberValidationSchema,
    contractId: yup_rules_1.dbIdValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map